
<modal
  hide-header
  size="large"
  :open="showWelcomeModal"
  @close="closeWelcome"
>
  <div class="welcome-modal">
    <icon-button class="close-button" icon="close" @click="closeWelcome" />

    <h4>Welcome to</h4>

    <full-logo pro />

    <p class="main-paragraph">
      Card Ladder Pro is feature rich, allowing you to take your collecting and investing to the next level. Here are a couple of suggestions to help you get started.
    </p>

    <div class="cta-options">
      <cta-card
        icon="space_dashboard"
        title="Customize your dashboard"
        description="Your dashboard is your homepage, so make it your own by choosing which widgets you want to see."
        @click="closeWelcome"
      />

      <cta-card
        as="router-link"
        to="/collection"
        icon="view_carousel"
        title="Upload your collection"
        description="Track the value of any card in you have in your collection, whether we have it in our database or not."
      />

      <cta-card
        as="router-link"
        to="/sales-history"
        icon="search"
        title="Find the value of any card"
        description="Use the Card Ladder sales history to search our massive database of sales and get current price estimates."
      />
    </div>

    <br />

    <p>PS: Don't forget to download the mobile app for <a href="https://apps.apple.com/us/app/card-ladder/id1541535971" target="_blank" rel="noopener noreferrer">iOS</a> and <a href="https://play.google.com/store/apps/details?id=com.ladderstudios.cardladder" target="_blank" rel="noopener noreferrer">Android</a> 😉</p>
  </div>
</modal>
